<template>
    <footer class="footer">
        <nav class="footer-nav">
            <div class="footer-list" v-for="(group, gIndex) in groupedMenu" :key="'group-' + gIndex">
                <div class="footer-item" v-for="menuItem in group" :key="menuItem.name">
                    <!-- Router対応（HOME / NEW ARRIVAL / BRANDS / CATEGORY / WEEKLY RANKING / MONTHLY RANKING） -->
                    <router-link v-if="menuItem.to" class="footer-link" :to="menuItem.to">{{ menuItem.name }}</router-link>
                    <a v-else-if="menuItem.link" class="footer-link" :href="menuItem.link[$store.state.hostName]">{{ menuItem.name }}</a>
                </div>
            </div>
            <div class="footer-list">
                <div class="footer-item" v-for="s in sns" :key="s.link" :class="s.name">
                    <a class="footer-link" :href="s.link">{{ s.name }}</a>
                </div>
            </div>
        </nav>
        <div class="footer-copy">&copy; RODEO BROS</div>
    </footer>
</template>

<script>
export default {
  name: 'Footer',

  data () {
    return {
      menu: [
        {
          name: 'HOME',
          to: '/',
          link: {
            R1: 'https://www.rakuten.ne.jp/gold/auc-rodeo/pc/',
            R2: 'https://www.rakuten.ne.jp/gold/rodeo-2nd/',
            Y1: 'https://shopping.geocities.jp/rodeobros/',
            Y2: 'https://shopping.geocities.jp/bros/',
            O: 'https://www.aun-wa.com/',
            W: '/user/24431709/plus/',
            Q: 'https://www.qoo10.jp/shop/RODEO-BROS'
          }
        },
        {
          name: 'NEW ARRIVAL',
          to: '/new',
          link: {
            R1: 'https://www.rakuten.ne.jp/gold/auc-rodeo/more/newarrival.html',
            R2: 'https://www.rakuten.ne.jp/gold/rodeo-2nd/more/newarrival.html',
            Y1: 'https://shopping.geocities.jp/rodeobros/more/newarrival.html',
            Y2: 'https://shopping.geocities.jp/bros/more/newarrival.html',
            O: 'https://www.aun-wa.com/more/newarrival.html',
            W: '/user/24431709/plus/more/newarrival.html',
            Q: 'https://www.qoo10.jp/shop/RODEO-BROS?minishop_bar_onoff=N&keyword_hist=&sell_coupon_cust_no=nEBWLVMMrHp1aCZrWC1CqA%3D%3D&SellerCooponDisplay=Y&sell_cust_no=nEBWLVMMrHp1aCZrWC1CqA%3D%3D&theme_sid=0&page_type=&global_yn=N&frame_id=&qid=0&search_mode=&fbidx=-1&brandno=&group_code=&gdlc_cd=&gdmc_cd=&gdsc_cd=&delivery_group_no=&sortType=SORT_GD_NO&dispType=UIG4&flt_pri_idx=&filterDelivery=NNNNNANNNN&search_global_yn=N&basis=&shipFromNation=&shipto=ALL&SearchNationCode=&is_research_yn=Y&hid_keyword=&video_goods_yn=&coupon_filter_no=&gd_type=&drugs_type=&promotion_yn=&priceMin=&priceMax=&curPage=1&pageSize=60&partial=on&brandno=&paging_value=2#div_section_filter'
          }
        },
        {
          name: 'BRANDS',
          to: '/brands',
          link: {
            R1: 'https://www.rakuten.ne.jp/gold/auc-rodeo/brandlist1/',
            R2: 'https://www.rakuten.ne.jp/gold/rodeo-2nd/brandlist1/',
            Y1: 'https://shopping.geocities.jp/rodeobros/brandlist1/',
            Y2: 'https://shopping.geocities.jp/bros/brandlist1/',
            O: 'https://www.aun-wa.com/brandlist1/',
            W: '',
            Q: ''
          }
        },
        {
          name: 'CATEGORY',
          to: '/category',
          link: {
            R1: 'https://item.rakuten.co.jp/auc-rodeo/c/',
            R2: 'https://item.rakuten.co.jp/rodeo-2nd/c/',
            Y1: 'https://store.shopping.yahoo.co.jp/rodeobros/item5bbea6.html',
            Y2: '',
            O: 'https://www.aun-wa.com/categorylist/',
            W: '',
            Q: ''
          }
        },
        {
          name: 'WEEKLY RANKING',
          to: '/weekly-ranking',
          link: {
            R1: 'https://www.rakuten.ne.jp/gold/auc-rodeo/more/week.html',
            R2: 'https://www.rakuten.ne.jp/gold/rodeo-2nd/more/week.html',
            Y1: 'https://shopping.geocities.jp/rodeobros/more/week.html',
            Y2: 'https://shopping.geocities.jp/bros/more/week.html',
            O: 'https://www.aun-wa.com/more/week.html',
            W: '',
            Q: ''
          }
        },
        {
          name: 'MONTHLY RANKING',
          to: '/monthly-ranking',
          link: {
            R1: 'https://www.rakuten.ne.jp/gold/auc-rodeo/more/month.html',
            R2: 'https://www.rakuten.ne.jp/gold/rodeo-2nd/more/month.html',
            Y1: 'https://shopping.geocities.jp/rodeobros/more/month.html',
            Y2: 'https://shopping.geocities.jp/bros/more/month.html',
            O: 'https://www.aun-wa.com/more/month.html',
            W: '',
            Q: ''
          }
        },
        {
          name: 'REVIEW',
          link: {
            R1: 'https://review.rakuten.co.jp/shop/4/235529_235529/1.1/',
            R2: 'https://review.rakuten.co.jp/shop/4/330657_330657/1.1/',
            Y1: 'https://shopping.yahoo.co.jp/store_rating/rodeobros/store/review/',
            Y2: 'https://shopping.yahoo.co.jp/store_rating/bros/store/review/',
            O: 'https://www.aun-wa.com/SHOP/rating_list.html',
            W: '/bep/m/kevl10?user=24431709',
            Q: ''
          }
        },
        {
          name: 'MAIL MAGAZINE',
          link: {
            R1: 'https://www.rakuten.co.jp/auc-rodeo/news.html',
            R2: 'https://www.rakuten.co.jp/rodeo-2nd/news.html',
            Y1: 'https://snlweb.shopping.yahoo.co.jp/shp_snl/optin/select/rodeobros',
            Y2: 'https://snlweb.shopping.yahoo.co.jp/shp_snl/optin/select/bros',
            O: 'https://www.aun-wa.com/SHOP/mailmag.html',
            W: '/bep/m/dm40?user=24431709',
            Q: ''
          }
        },
        {
          name: 'COMPANY',
          link: {
            R1: '#/company',
            R2: '#/company',
            Y1: '#/company',
            Y2: '#/company',
            O: '#/company',
            W: '/bep/m/kpaax04?l=shp_005&d=/user/24431709/2',
            Q: 'https://www.qoo10.jp/shop-info/RODEO-BROS?global_yn=N'
          }
        }
      ],
      menuGroups: [
        ['HOME', 'NEW ARRIVAL', 'BRANDS'],
        ['CATEGORY', 'WEEKLY RANKING', 'MONTHLY RANKING'],
        ['REVIEW', 'MAIL MAGAZINE', 'COMPANY']
      ],
      sns: [
        {
          name: 'instagram',
          path: 'instagram.svg',
          link: 'https://www.instagram.com/rodeobros/'
        },
        {
          name: 'twitter',
          path: 'twitter.svg',
          link: 'https://twitter.com/rodeobros'
        },
        {
          name: 'facebook',
          path: 'facebook.svg',
          link: 'https://www.facebook.com/Rodeobros/'
        }
      ]
    }
  },

  computed: {
    /**
         * グループごとに menu を振り分けた配列
         */
    groupedMenu () {
      return this.menuGroups.map(groupNames =>
        this.menu.filter(item => groupNames.includes(item.name))
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
    padding-top: 60px;
    padding-bottom: 40px;
    text-transform: uppercase;
    background-color: #222222;

    @media screen and (max-width: 722px) {
        padding-top: 40px;
        padding-bottom: 20px;
    }

    @media screen and (min-width: 723px) and (max-width: 963px) {}
}

.footer-nav {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    max-width: 1536px;
    margin: 0 auto;
    font-size: 16px;
    color: #ffffff;
    background-color: #222222;

    @media screen and (max-width: 722px) {
        grid-template-columns: repeat(2, 1fr);
        font-size: 15px;
    }

    @media screen and (min-width: 723px) and (max-width: 963px) {
        grid-template-columns: repeat(2, 1fr);
    }
}

.footer-list {
    padding-right: 80px;
    padding-left: 80px;

    @media screen and (max-width: 722px) {
        padding-right: 40px;
        padding-left: 40px;
    }
}

.footer-item {
    padding-top: 20px;

    @media screen and (max-width: 722px) {}
}

.footer-link {
    color: #ffffff;
    text-decoration: none;
    cursor: pointer;
    outline: none;
    transition: .3s ease;

    &:hover {
        opacity: .6;
    }
}

.footer-copy {
    max-width: 1536px;
    padding-top: 60px;
    margin: 0 auto;
    font-size: 13px;
    color: #ffffff;
    text-align: center;

    @media screen and (max-width: 722px) {
        padding-top: 20px;
        padding-right: 40px;
        padding-left: 40px;
        margin-top: 40px;
        text-align: left;
        border-top: 1px solid #ffffff;
    }
}
</style>
